module.exports = __webpack_public_path__ + "media/images/country_flags/sn-236050f94d4906677b198094b73ef294.png";